import { render, staticRenderFns } from "./editPersonalInformation.vue?vue&type=template&id=f8bf2088&scoped=true"
import script from "./editPersonalInformation.vue?vue&type=script&lang=js"
export * from "./editPersonalInformation.vue?vue&type=script&lang=js"
import style0 from "./editPersonalInformation.vue?vue&type=style&index=0&id=f8bf2088&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bf2088",
  null
  
)

export default component.exports